import React, { useEffect } from 'react';

export function useCprPanelDimensions(
  ref: React.RefObject<HTMLDivElement>,
  setDimensions: React.Dispatch<React.SetStateAction<{ width: number; height: number }>>,
) {
  useEffect(() => {
    if (!ref.current) return;

    const currentDiv = ref.current;
    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.contentRect) return;
        const { width, height } = entry.contentRect;
        setDimensions({ width, height });
      });
    });

    observer.observe(currentDiv);

    return () => {
      observer.unobserve(currentDiv);
    };
  }, [ref, setDimensions]);
}
